import { render, staticRenderFns } from "./PostPreviewAnswers.vue?vue&type=template&id=715ee71f&scoped=true"
import script from "./PostPreviewAnswers.vue?vue&type=script&lang=js"
export * from "./PostPreviewAnswers.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewAnswers.vue?vue&type=style&index=0&id=715ee71f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ee71f",
  null
  
)

export default component.exports